export default __webpack_public_path__ + "static/media/Bonito1BRAINFERG.1c6a7468.xml";